import React, { Component, Fragment } from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import Form from "assets/scripts/components/common/form/Form/Form";
import { getPersonalInfoErrors } from "../utils";
import PersonalInfoFields from "../PersonalInfoFields/PersonalInfoFields";
const messages = defineMessages({
    firstNameLabel: {
        id: "forms.payNow.firstName.label",
        defaultMessage: "First Name"
    },
    lastNameLabel: {
        id: "forms.payNow.lastName.label",
        defaultMessage: "Last Name"
    },
    addressLabel: {
        id: "forms.payNow.address.label",
        defaultMessage: "Address"
    },
    address2Label: {
        id: "forms.payNow.address2.label",
        defaultMessage: "Address 2"
    },
    cityLabel: {
        id: "forms.payNow.city.label",
        defaultMessage: "City"
    },
    cityHelp: {
        id: "forms.payNow.city.help",
        defaultMessage: "Example: Springfield"
    },
    stateLabel: {
        id: "forms.payNow.state.label",
        defaultMessage: "State"
    },
    stateHelp: {
        id: "forms.payNow.state.help",
        defaultMessage: "Example: AK"
    },
    zipLabel: {
        id: "forms.payNow.zip.label",
        defaultMessage: "Zip"
    },
    zipHelp: {
        id: "forms.payNow.zip.help",
        defaultMessage: "Example: 12345"
    },
    phoneLabel: {
        id: "forms.payNow.phone.label",
        defaultMessage: "Phone"
    },
    phoneHelp: {
        id: "forms.payNow.phone.help",
        defaultMessage: "Example: 123-456-7890"
    },
    emailLabel: {
        id: "forms.payNow.email.label",
        defaultMessage: "Email"
    },
    next: {
        id: "forms.payNow.personalInfo.next",
        defaultMessage: "Next"
    }
});
export default class PersonalInfoForm extends Component {
    constructor() {
        super(...arguments);
        this._renderButtons = ({ renderSubmitButton }) => {
            return (<Fragment>
				<button type="button" className="btn mix-btn_fixedWidth btn-action" onClick={this.props.onBack}>
					<FormattedMessage id="forms.payNow.personalInfo.back" defaultMessage="Back"/>
				</button>
				{" "}
				{renderSubmitButton()}
			</Fragment>);
        };
    }
    render() {
        const { props } = this;
        const errors = getPersonalInfoErrors(props.value, props.hideEmail);
        const isValid = Object.values(errors).every(it => it == null);
        return (<Fragment>
				<div className="vr vr_x4">
					<h1 className="hdg">
						<FormattedMessage id="forms.payNow.personalInfo.legend" defaultMessage="Personal Information"/>
					</h1>
				</div>

				<Form isBusy={props.isLoading} isValid={isValid} onSubmit={props.onContinue} submitLabel={messages.next} error={props.globalError} renderButtons={this._renderButtons}>
					<fieldset className="fieldset fieldset-depth-0">
						<PersonalInfoFields {...props} errors={errors}/>
					</fieldset>
				</Form>
			</Fragment>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/PersonalInfoForm/PersonalInfoForm.tsx